module.exports = __webpack_public_path__ + "img/orgranization-services.db9e67a.svg";